// extracted by mini-css-extract-plugin
export default {"container":"AddCardModal_container__8BaV2","label":"AddCardModal_label__vDU6m","input":"AddCardModal_input__Y+-wC","saveButton":"AddCardModal_saveButton__-tdmk"};